export const START_SEARCH_PACKS = 'START_SEARCH_PACKS'
export const START_NEW_SEARCH_PACKS = 'START_NEW_SEARCH_PACKS'
export const SUCCESS_SEARCH_PACKS = 'SUCCESS_SEARCH_PACKS'
export const ERROR_SEARCH_PACKS = 'ERROR_SEARCH_PACKS'